/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unescaped-entities */

import React from 'react';

import Box from '@ntuctech/devex-tangram/Box';
import Typography from '@ntuctech/devex-tangram/Typography';

import PageContent from '../theme/PageContent';
import PageHeader from '../theme/PageHeader';
import ForgotForm from './ForgotForm';

export default () => {
  return (
    <>
      <PageContent>
        <PageHeader header="Password reset link" />
        <Box mt={-3} mb={3}>
          <Typography>
            Enter your email address and we’ll send you a link to reset your password.
          </Typography>
        </Box>
        <ForgotForm />
      </PageContent>
    </>
  );
};
